import "./LandingPage.scss";

import { faShare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';

export default function LandingPage() {
  return (
    <Fragment>
      <div className='__landing'>
        <section className='banner'>
          <div className='banner__container container'>
            <div className='banner__overlay overlay'>
              <div className='overlay__content'>
                <div className='overlay__image image image-001' />
              </div>
            </div>
            <div className='banner__content content'>
              <h1 className='content__title'>
                Find your next <br />
                <span>GIG</span>
              </h1>
              <Link to='jobs' className='content__button button button--large button--fill button--primary'>
                Browse Gigs <FontAwesomeIcon icon={faShare} />
              </Link>
            </div>
          </div>
        </section>
        <section className='section section--primary'>
          <h3 className='section__title title title--center container'>
            Cut through the noise.<br />
            No endless threads.<br />
            Just gigs you can apply to today.<br />
          </h3>
        </section>
        <section className='section section--transparent'>
          <div className='section__grid grid container'>
            <div className='grid__column column column--middle'>
              <h3 className='section__title title'>
                Dynamic gig board for <br /> working musicians.
              </h3>
              <p className='section__description description description--large'>
                Filter by genre, location, and <br /> budget — no endless scrolling.
              </p>
            </div>
            <div className='grid__column'>
              <div className='image image-002' />
            </div>
          </div>
        </section>
        <section className='section section--primary'>
          <div className='section__grid grid container'>
            <div className='grid__column'>
              <div className='image image-003' />
            </div>
            <div className='grid__column column column--middle'>
              <h3 className='section__title title'>
                Every artist on Papaya <br /> builds a real profile
              </h3>
              <p className='section__description description description--small'>
                Papaya is built by musicians, for musicians. Profiles highlight verified skills and performance history, and gigs are community-sourced from trusted industry spaces.
              </p>
              <Link to='/jobs' className='section__button--end button button--large button--black'>
                Get Started <FontAwesomeIcon icon={faShare} />
              </Link>
            </div>
          </div>
        </section>
        <section className='section section--transparent section--brand-right'>
          <div className='section__grid grid container'>
            <div className='grid__column'>
              <div className='section__image--image-004 image image-004' />
            </div>
            <div className='grid__column column column--middle'>
              <h3 className='section__title title'>
                Your art in one page.
              </h3>
              <p className='section__description description description--large'>
                Connect all your social and music platforms and promote your tracks, playlists and upcoming events.
              </p>
            </div>
          </div>
        </section>
      </div>
    </Fragment>
  );
}